'use client';
import { Copyright as SharedCopyright } from '@launchstore/shared-puck';
import type { CopyrightProps } from '@launchstore/shared-puck';
export const Copyright: any = SharedCopyright;
export type { CopyrightProps };
export default Copyright;
